<template>
   <div v-if="!loadingCameraSetup">
      <a v-b-modal.qrModal v-if="isMobile && hasCameras">
         <span class="icon-qr mr-4"></span>
      </a>
      <dropdown-nav v-else-if="canRead('GLOBAL_SEARCH')" key="searchDropdown" ref="searchDropdown" class="mr-4">
         <template slot="label">
            <span class="icon-search"></span>
         </template>
         <search-dropdown></search-dropdown>
      </dropdown-nav>
      <dropdown-nav v-if="showSamples" key="sampleDropdown" ref="sampleDropdown" class="mr-4" arrow="center">
         <template slot="label">
            <span class="icon-swatchbook"></span>
            <b-badge class="header">{{ sampleCount }}</b-badge>
         </template>
         <sample-dropdown @navigate="$refs.sampleDropdown.forceHide()"></sample-dropdown>
      </dropdown-nav>
      <dropdown-nav v-if="!(isMobile && hasCameras)" key="favoritesDropdown" ref="favoritesDropdown" class="mr-4"
                    arrow="right">
         <template slot="label">
            <span class="icon-heart"></span>
            <b-badge class="header">{{ favorites.length }}</b-badge>
         </template>
         <favorites-dropdown></favorites-dropdown>
      </dropdown-nav>
      <dropdown-nav key="cartDropdown" ref="cartDropdown" class="mr-4" arrow="right">
         <template slot="label">
            <span class="icon-cart"></span>
            <b-badge class="header">{{ itemCount }}</b-badge>
         </template>
         <cart-dropdown @navigate="$refs.cartDropdown.forceHide()"></cart-dropdown>
      </dropdown-nav>
      <router-link
          :to="{ name: 'contentList', params: { listName: 'faq' } }"
          class="mr-3"
      >
         <span class="icon-info"></span>
      </router-link>
      <dropdown-nav key="userDetailsNav" arrow="right" @menuVisible="userDetailDropdown">
         <template slot="no-hover">
            <pb-callout id="planning-callout"
                        v-if="!menuOpenedAtLeastOnce && ($config['external_planning_link_show_callout'] === '1')">
               Check here for an appointment for a personal tour trough our collection
            </pb-callout>
         </template>
         <template slot="label">
            <span class="icon-user"/>
         </template>
         <div class="p-3">
            <b-nav vertical class="sub-nav text-left mb-2">
               <b-nav-item style="position: relative; font-size: 13px !important;" :to="{ name: 'personal'}">
                  <i class="fal fa-1x fa-inline fa-cog"></i> Settings
               </b-nav-item>
               <b-nav-item style="position: relative; font-size: 13px !important;"
                           :href="$config['external_planning_link']" target="_blank"
                           v-if="$config['external_planning_link']">
                  <i class="fal fa-1x fa-inline fa-calendar-plus"></i> Appointment for a personal tour
               </b-nav-item>
            </b-nav>
            <pb-btn :busy="loggingOut" @click.native="onLogout" sm block variant="primary">SIGN OUT <i
                class="fal fa-sign-out fa-sm fa-inline"></i>
            </pb-btn>
         </div>
      </dropdown-nav>
      <qr-modal ref="qrModal" id="qrModal">
      </qr-modal>
      <simple-contact-modal
          ref="simpleContactModal"
          id="simpleContactModal">
      </simple-contact-modal>
   </div>
</template>

<script>

import {mapActions, mapGetters, mapState} from "vuex";
import DropdownNav from "../../../../components/DropdownNav";
import QrSearchModal from "../../ui/QrSearchModal";
import DMIContactModal from "../../../pages/DMIContactModal";
import SampleDropdown from "./samples/SampleDropdown";
import FavoritesDropdown from "./favorites/FavoriteDropdown";
import SearchDropdown from "./search/SearchDropdown";
import CartDropdown from "./cart/CartDropdown";

export default {
   name: 'user-bar',
   data() {
      return {
         loggingOut: false,
         hasCameras: false,
         loadingCameraSetup: false,
         menuOpenedAtLeastOnce: false,
      };
   },
   mounted() {
      this.loadingCameraSetup = true;
      navigator.mediaDevices.enumerateDevices().then((devices) => {
         devices.forEach(mediaDevice => {
            if (mediaDevice.kind.indexOf("video") !== -1) {
               this.hasCameras = true;
            }
         })
      }).finally(() => {
         this.loadingCameraSetup = false
      });
   },
   components: {
      'favorites-dropdown': FavoritesDropdown,
      'sample-dropdown': SampleDropdown,
      'search-dropdown': SearchDropdown,
      'dropdown-nav': DropdownNav,
      'qr-modal': QrSearchModal,
      'cart-dropdown': CartDropdown,
      'simple-contact-modal': DMIContactModal,
   },
   methods: {
      ...mapActions('account', ['login', 'logout']),
      ...mapActions('cart', ['fetchCart']),
      ...mapActions('favorites', ['fetchFavorites']),
      ...mapActions('sample', ['fetchSampleList']),
      userDetailDropdown(isVisible) {
         if (!this.menuOpenedAtLeastOnce) {
            this.menuOpenedAtLeastOnce = isVisible;
         }
      },
      onLogout() {
         this.loggingOut = true;
         this.logout().then(() => {
            this.$router.push('/');
         }).finally(() => {
            this.loggingOut = false;
         });
      },
   },
   computed: {
      ...mapState('account', ['user']),
      ...mapGetters('cart', ['itemCount']),
      ...mapGetters('sample', ['sampleCount']),
      ...mapGetters('favorites', ['favorites']),
      ...mapGetters('account', ['hasRole', 'canRead']),
      ...mapGetters('media', ['isMobile', 'isDesktop']),
      showSamples: function () {
         return this.isDesktop && this.user && this.user.externalData && (this.user.externalData.customerCategory === 'A' || this.user.externalData.customerCategory === 'B' || this.hasRole('Admin'));
      }
   },
}
</script>

<style lang="scss" scoped>
@import "~@shared/_assets/scss/constants";

.user-bar {

   .sub-nav {
      a {
         font-size: 15px;
         font-weight: 300;
         font-family: Roboto, sans-serif;
         letter-spacing: 0.33px;

         &:hover {
            font-weight: 500;
            letter-spacing: 0.23px;
         }
      }
   }
}
</style>
